module.exports = __webpack_public_path__ + "img/blue-video.7dcc5ec4.svg";